<template>
  <div id="partners">
    <div class="container">
      <transition class="fade" name="fade" mode="out-in">
        <router-view :getAgents="getAgents" />
      </transition>
      <div v-if="this.$route.name === 'editagent'">
        <a @click="goToAdd" class="back">{{ parseTranslation(ADD_AGENT) }} </a>
      </div>
      <div class="partnersList" v-if="agents">
        <h2>{{ parseTranslation(AGENTS) }}</h2>
        <div class="partners">
          <div>
            <p>{{ parseTranslation(NAME) }}</p>
            <p>{{ parseTranslation(REDIRECT) }}</p>
            <p>{{ parseTranslation(NUMBER) }}</p>
            <p>{{ parseTranslation(EDIT) }}</p>
          </div>
          <div class="partner" v-for="agent in agents" :key="agent.id">
            <p>{{ agent.agent }}</p>
            <p @click="copy(agent.redirect)">{{ agent.redirect }}</p>
            <p>{{ agent.source }}</p>

            <button @click="goToEdit(agent.id)">
              <Engine />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import copyToClipboard from 'copy-to-clipboard'

import Engine from '@/components/imgs/Engine'

import * as translationAgents from './index.translations'

const { default: translations, ...translationKeys } = translationAgents

export default {
  name: 'Agents',

  components: { Engine },

  data() {
    return {
      translations,
      ...translationKeys,
      agents: null,
      option: 'add',
    }
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async getAgents() {
      const surveyAgents = await this.executeSurveyAPICall({
        path: 'survey/agents',
        queryParams: { survey_id: this.$route.query.surveyId },
      })

      if (!surveyAgents) return

      this.agents = surveyAgents
    },

    goToAdd() {
      this.option = 'add'

      this.$router.push({
        name: 'addagent',
        query: { surveyId: this.$route.query.surveyId },
      })
    },

    goToEdit(id) {
      this.option = 'edit'

      this.$router.push({
        name: 'editagent',
        query: { id, surveyId: this.$route.query.surveyId },
      })
    },

    copy(link) {
      if (link === 'No link.')
        return this.sendMessage(this.translations[this.language][this.NO_LINK])

      copyToClipboard(link)
      this.sendMessage(this.translations[this.language][this.COPY_LINK])
    },
  },
  created() {
    this.getAgents()
  },
}
</script>

<style lang="scss" scoped>
.partnersList {
  margin-top: 60px;
  @include tipography(20);
  font-weight: bold;
  .light & {
    color: $gray-6;
  }
}

.partners {
  margin: 40px 0;
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 40px;
    background: $gray-7;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    transition: all 1s ease-in-out;
  }

  div {
    display: flex;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: $gray-7;
    transition: all 1s ease-in-out;
    margin-bottom: 5px;
    overflow-x: auto;
    overflow-y: hidden;

    @include tipography(14);
    p {
      min-width: 100px;
      padding: 10px;
      display: flex;
      justify-content: center;
      &:first-of-type,
      &:nth-of-type(2) {
        flex: 1;
        justify-content: start;
      }
      &:nth-of-type(2) {
        cursor: pointer;
      }
    }
  }
  .light & {
    div:first-of-type,
    &::after {
      background: $white;
    }
    div:first-of-type {
      color: $gray-6;
    }
  }
}

.partner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: $gray-7;
  margin-bottom: 5px;
  transition: all 1s ease-in-out;
  overflow-x: auto;
  overflow-y: hidden;

  p {
    font-weight: normal;
    padding: 10px;
    @include tipography(14);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    &:nth-of-type(1) {
      flex: 1;
    }
    &:nth-of-type(2) {
      width: 100px;
      display: flex;
      justify-content: center;
    }
  }
  button {
    width: 100px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    @include transparentButton;

    &:focus {
      outline: none;
    }

    svg {
      @include boxSizing(25);
    }
  }
  .light & {
    background: $white;
    color: $gray-6;
    p {
      color: $gray-6;
    }
  }
}

.back {
  display: flex;
  align-items: center;
  margin-right: 15px;
  @include tipography(14);
  cursor: pointer;
  height: 20px;
  &::before {
    content: '';
    display: block;
    width: 15px;
    height: 15px;
    background: url(../../assets/imgs/back.svg) no-repeat center;
    margin-right: 5px;
  }
  .light & {
    color: $gray-4;
    &::before {
      background: url(../../assets/imgs/back_dark.svg) no-repeat center;
    }
  }
}
</style>
